module.exports = __webpack_public_path__ + "img/bxs-liked.5fc8fcc7.svg";